import axios from 'axios';

export const sendNotification = async (title: string, message: string, user: number) => {
    try {
        const response = await axios.post('/notifications/new_notification/', {
            title,
            message,
            user,
        });
        return {
            success: true,
            status: response.status,
            data: response.data,
        };
    } catch (error: any) {
        return {
            success: false,
            status: error.response?.status || 500,
            error: error.response?.data || error.message,
        };
    }
}